import { Component, inject } from '@angular/core';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';

@Component({
  selector: 'cx-paragraph',
  templateUrl: './cx-paragraph.component.html',
})
export class CxParagraphComponent {
  protected data = inject<{ content: string }>(CX_ABSTRACT_COMPONENT_DATA);
}
